import { useQuery } from "@tanstack/react-query";

import { getFarmPaymentItems } from "services";

import { GET_FARM_PAYMENT_ITEMS } from "consts";

import { FarmPaymentItemsResponse } from "models";

export const useGetFarmPaymentItems = () => {
  const { data, isLoading, isSuccess } = useQuery<FarmPaymentItemsResponse[]>({
    queryKey: [GET_FARM_PAYMENT_ITEMS],
    queryFn: () => getFarmPaymentItems(),
  });

  return {
    farmPaymentItems: isSuccess ? data : null,
    isLoadingPaymentItems: isLoading,
  };
};
